import type { TFunction } from 'i18next'

import { ApiError } from '@/lib/api/http-client'

const errorTranslationKey: Record<string, string> = {
  'agent_tools.agent_not_found': 'errors.codes.agentNotFound',
  'agent_tools.binding_conflict': 'errors.codes.bindingConflict',
  'agent_tools.definition_changed': 'errors.codes.definitionChanged',
  'agent_tools.invalid_agent_type': 'errors.codes.invalidAgentType',
  'agent_tools.invalid_bindings': 'errors.codes.invalidBindings',
  'agent_tools.tool_name_conflict': 'errors.codes.toolNameConflict',
  'agent_tools.unknown_tool': 'errors.codes.unknownTool',
  'agent_tools.write_forbidden': 'errors.codes.writeForbidden',
  'mcp.connection.conflict': 'errors.codes.connectionConflict',
  'mcp.connection.external_oauth_config_invalid': 'errors.codes.externalOAuthConfigInvalid',
  'mcp.connection.in_use': 'errors.codes.connectionInUse',
  'mcp.connection.not_found': 'errors.codes.connectionNotFound',
  'mcp.connection.revision_conflict': 'errors.codes.connectionRevisionConflict',
  'mcp.connection.target_immutable': 'errors.codes.targetImmutable',
  'mcp.connection.target_invalid': 'errors.codes.targetInvalid',
  'mcp.connection.write_forbidden': 'errors.codes.writeForbidden',
  'mcp.connection.header_unavailable': 'errors.codes.oauthCredentialUnavailable',
  'mcp.discovery.authentication_failed': 'errors.codes.discoveryAuthenticationFailed',
  'mcp.discovery.compressed_response': 'errors.codes.discoveryInvalidResponse',
  'mcp.discovery.connection_failed': 'errors.codes.discoveryConnectionFailed',
  'mcp.discovery.dns_failed': 'errors.codes.discoveryConnectionFailed',
  'mcp.discovery.duplicate_tool_name': 'errors.codes.discoveryInvalidCatalog',
  'mcp.discovery.endpoint_rejected': 'errors.codes.discoveryEndpointRejected',
  'mcp.discovery.invalid_catalog': 'errors.codes.discoveryInvalidCatalog',
  'mcp.discovery.invalid_response': 'errors.codes.discoveryInvalidResponse',
  'mcp.discovery.protocol_error': 'errors.codes.discoveryInvalidResponse',
  'mcp.discovery.redirect_rejected': 'errors.codes.discoveryEndpointRejected',
  'mcp.discovery.repeated_cursor': 'errors.codes.discoveryInvalidCatalog',
  'mcp.discovery.response_too_large': 'errors.codes.discoveryResponseTooLarge',
  'mcp.discovery.timeout': 'errors.codes.discoveryTimeout',
  'mcp.discovery.tools_not_supported': 'errors.codes.discoveryToolsNotSupported',
  'mcp.oauth.authorization_unavailable': 'errors.codes.oauthAuthorizationUnavailable',
  'mcp.oauth.authorization_denied': 'errors.codes.oauthAuthorizationDenied',
  'mcp.oauth.authorization_failed': 'errors.codes.oauthAuthorizationFailed',
  'mcp.oauth.client_auth_method_unavailable': 'errors.codes.oauthClientAuthMethodUnavailable',
  'mcp.oauth.connection_failed': 'errors.codes.oauthAuthorizationUnavailable',
  'mcp.oauth.credential_unavailable': 'errors.codes.oauthCredentialUnavailable',
  'mcp.oauth.not_configured': 'errors.codes.oauthNotConfigured',
  'mcp.oauth.flow_not_found': 'errors.codes.oauthFlowExpired',
  'mcp.oauth.issuer_mismatch': 'errors.codes.oauthIssuerMismatch',
  'mcp.oauth.issuer_unavailable': 'errors.codes.oauthIssuerUnavailable',
  'mcp.oauth.resolver_unavailable': 'errors.codes.oauthResolverUnavailable',
  'mcp.oauth.unavailable': 'errors.codes.oauthAuthorizationUnavailable',
}

/** 将后台异步 flow 返回的稳定 error_code 映射为同一套管理端文案。 */
export function agentToolsErrorCodeMessage(
  errorCode: string | null,
  t: TFunction<'adminAgentTools'>,
  fallbackKey = 'errors.operationFailed',
) {
  const key = errorCode ? errorTranslationKey[errorCode] : undefined
  return key ? t(key) : t(fallbackKey)
}

/** 按稳定 error_code 映射后台主文案，不把后端 raw message 当成用户提示。 */
export function agentToolsErrorMessage(
  error: unknown,
  t: TFunction<'adminAgentTools'>,
  fallbackKey = 'errors.operationFailed',
) {
  if (error instanceof ApiError && error.errorCode) {
    const key = errorTranslationKey[error.errorCode]
    if (key) {
      return t(key)
    }
  }

  return t(fallbackKey)
}
